import { MobiDocument } from './MobiDocument';
import { Individu } from './Individu';
import { NiveauScolaireDocument } from './NiveauScolaireDocument';
import { EtablissementScolaireDocument } from './EtablissementScolaireDocument';
import { ClasseScolaireDocument } from './ClasseScolaireDocument';
import { EnseignantScolaireDocument } from './EnseignantScolaireDocument';

export class HistoScolarite extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private individu_id: number;
    private etablissementscolaire_id: number;
    private classescolaire_id: number;
    private enseignant_id: number;
    private niveauscolaire_id: number;
    private anneescolaire_id: number;







    public constructor(histo: any) {
        super()
        this._id = histo._id;
        this._rev = histo._rev;
        this.id = histo.id;
        this.individu_id = histo.individu_id;
        this.etablissementscolaire_id = histo.etablissementscolaire_id;
        this.classescolaire_id = histo.classescolaire_id;
        this.enseignant_id = histo.enseignant_id;
        this.niveauscolaire_id = histo.niveauscolaire_id;
        this.anneescolaire_id = histo.anneescolaire_id;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getIndividu_id(): number {
        return this.individu_id;
    }

    public setIndividu_id(individu_id: number): void {
        this.individu_id = individu_id;
    }

    public getEtablissementscolaire_id(): number {
        return this.etablissementscolaire_id;
    }

    public setEtablissementscolaire_id(etablissementscolaire_id: number): void {
        this.etablissementscolaire_id = etablissementscolaire_id;
    }

    public getClassescolaire_id(): number {
        return this.classescolaire_id;
    }

    public setClassescolaire_id(classescolaire_id: number): void {
        this.classescolaire_id = classescolaire_id;
    }

    public getEnseignant_id(): number {
        return this.enseignant_id;
    }

    public setEnseignant_id(enseignant_id: number): void {
        this.enseignant_id = enseignant_id;
    }

    public getNiveauscolaire_id(): number {
        return this.niveauscolaire_id;
    }

    public setNiveauscolaire_id(niveauscolaire_id: number): void {
        this.niveauscolaire_id = niveauscolaire_id;
    }

    public getEnseignant(): EnseignantScolaireDocument | undefined {
        try {
            return this.memdb.findOne({
                doctype: "EnseignantDocument",
                fkey: "id",
                fvalue: this.enseignant_id
            });
        } catch (error) {
            return undefined;
        }

    }

    public getIndividu(): Individu | undefined {
        try {
            return this.memdb.findOne({
                doctype: "IndividuDocument",
                fkey: "id",
                fvalue: this.individu_id
            });
        } catch (error) {
            return undefined;
        }

    }

    public getEtablissementScolaire(): EtablissementScolaireDocument | undefined {
        try {
            return this.memdb.findOne({
                doctype: "EtablissementScolaireDocument",
                fkey: "id",
                fvalue: this.etablissementscolaire_id
            });
        } catch (error) {
            return undefined;
        }

    }

    public getClasseScolaire(): ClasseScolaireDocument | undefined {
        try {
            return this.memdb.findOne({
                doctype: "ClasseScolaireDocument",
                fkey: "id",
                fvalue: this.classescolaire_id
            });
        } catch (error) {
            return undefined;
        }

    }

    public getNiveauScolaire(): NiveauScolaireDocument | undefined {
        try {
            return this.memdb.findOne({
                doctype: "NiveauScolaireDocument",
                fkey: "id",
                fvalue: this.niveauscolaire_id
            });
        } catch (error) {
            return undefined;
        }

    }
    public getAnneescolaire_id(): number {
        return this.anneescolaire_id;
    }

    public setAnneescolaire_id(anneescolaire_id: number): void {
        this.anneescolaire_id = anneescolaire_id;
    }


}